import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledTableContainer = styled('div', {
  maxHeight: '59vh',
  overflowY: 'scroll',
});

const StyledTable = styled('table', {
  width: '100%',
});

const StyledTableRow = styled('tr', {
  borderBottom: '1px solid $gray4',
  borderTop: '1px solid $gray4',
  '&:hover': {
    backgroundColor: '$tint2',
  },
  cursor: 'pointer',
});

const StyledTableData = styled('td', {
  padding: '8px 15px',
});

export const PayerTableData = ({
  colWidths,
  data,
  renderRow,
  noResultsMessage = 'No results found',
}) => {
  if (!data || data.length === 0) {
    return (
      <StyledTableContainer>
        <StyledTable>
          <StyledTableRow
            css={{
              borderBottom: 'none',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              cursor: 'default',
            }}
          >
            <StyledTableData colSpan='2' style={{ color: 'black' }}>
              {noResultsMessage}
            </StyledTableData>
          </StyledTableRow>
        </StyledTable>
      </StyledTableContainer>
    );
  }
  return (
    <StyledTableContainer>
      <StyledTable>
        <colgroup>
          {colWidths.map((width, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <col key={index} style={{ width }} />
          ))}
        </colgroup>
        <tbody>{renderRow(data)}</tbody>
      </StyledTable>
    </StyledTableContainer>
  );
};

PayerTableData.propTypes = {
  colWidths: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  renderRow: PropTypes.func.isRequired,
  noResultsMessage: PropTypes.string,
};

PayerTableData.defaultProps = {
  noResultsMessage: 'No results found',
};
